import { FlaskConical } from "lucide-react";
import { useConfig } from "../../lib/queries";

// Persistent, high-visibility disclosure that the on-chain layer is simulated,
// while keeping the accurate note that wallet connection + signing are real.
export const SimBanner = () => {
  const { data: cfg } = useConfig();
  if (!cfg?.simulated) return null;
  return (
    <div data-testid="sim-banner" className="shrink-0 h-8 flex items-center justify-center gap-2 px-4 bg-warn/15 border-b border-warn/40 text-warn">
      <FlaskConical size={13} className="shrink-0" />
      <span className="mono text-[11px] font-semibold uppercase tracking-[0.14em]">Simulated data</span>
      <span className="mono text-[11px] text-warn/80 hidden md:inline">— escrow deposits, releases &amp; pool prices are on-chain simulations. Wallet connection &amp; message signing are real.</span>
    </div>
  );
};
